import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import './AssistantLayout.css';
import ASHeader from '../../Header/ASHeader';
import AssistantMenu from '../../assistant/AssistantMenu';
import { AssistantProfile } from '../../assistant/AssistantProfile';
import { AssistantActivities } from '../../assistant/AssistantActivities';






interface AssitantLayout {

  children?: ReactNode;
  // Define children as a ReactNode
}
const AssitantLayout: React.FC<AssitantLayout> = ({ children }) => {


  return (
    <div className="elitecap-layout-container">
      <ASHeader/>
      <div >
        <AssistantMenu />
]          <Routes>
                     <Route path="/assistantprofile" element={<AssistantProfile />} />
                     <Route path="/assistantactivities" element={<AssistantActivities />} />


             
             




             






          </Routes>
      </div>
      { children }
      {/* <Footer /> */}
    </div>
  );
};

export default AssitantLayout;
